class CookieConsent {
  constructor() {
    this.banner = document.getElementById('cookie-banner')
    this.configureBtn = document.getElementById('cookie-configure-btn')
    this.modal = document.getElementById('cookie-modal')
    if (!this.banner) return
    this.init()
  }

  init() {
    const consent = localStorage.getItem('cookie-consent')
    if (!consent) {
      this.showBanner()
    }

    document.getElementById('cookie-accept')?.addEventListener('click', () => this.acceptAll())
    document.getElementById('cookie-reject')?.addEventListener('click', () => this.rejectAll())
    document.getElementById('cookie-save')?.addEventListener('click', () => this.savePreferences())
    document.getElementById('cookie-modal-close')?.addEventListener('click', () => this.closeModal())

    if (this.configureBtn) {
      this.configureBtn.addEventListener('click', () => this.openModal())
    }

    document.querySelectorAll('#cookie-modal .cookie-toggle').forEach(toggle => {
      if (toggle.dataset.required) {
        toggle.checked = true
        toggle.disabled = true
      }
    })
  }

  showBanner() {
    this.banner.classList.remove('translate-y-full')
    this.banner.classList.add('translate-y-0')
  }

  hideBanner() {
    this.banner.classList.remove('translate-y-0')
    this.banner.classList.add('translate-y-full')
  }

  acceptAll() {
    const prefs = { necessary: true, analytics: true, marketing: true }
    localStorage.setItem('cookie-consent', JSON.stringify(prefs))
    this.hideBanner()
  }

  rejectAll() {
    const prefs = { necessary: true, analytics: false, marketing: false }
    localStorage.setItem('cookie-consent', JSON.stringify(prefs))
    this.hideBanner()
  }

  savePreferences() {
    const prefs = {
      necessary: true,
      analytics: document.getElementById('cookie-analytics')?.checked || false,
      marketing: document.getElementById('cookie-marketing')?.checked || false
    }
    localStorage.setItem('cookie-consent', JSON.stringify(prefs))
    this.closeModal()
    this.hideBanner()
  }

  openModal() {
    if (this.modal) {
      this.modal.classList.remove('hidden')
      this.modal.classList.add('flex')
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.classList.remove('flex')
      this.modal.classList.add('hidden')
    }
  }
}

export default CookieConsent